<div class="checkbox medium-type" [ngClass]="{ 'checkbox-disabled': ctrlField().disabled }">
  <label class="checkbox-container flex ps-medium-r" [ngClass]="{ 'flex--center': center() }" [for]="checkboxId">
    <input
      class="is-vishidden"
      type="checkbox"
      [attr.aria-required]="required()"
      [attr.disabled]="ctrlField().disabled ? 'disabled' : null"
      [formControl]="$any(ctrlField())"
      [id]="checkboxId"
      [name]="controlName()"
      [value]="checkboxValue()"
      aria-describedby="checkbox-error-box"
    />
    @if (showCheckboxIcon()) {
      <span class="icons ms-xsmall-r nordic-blue-900-text" aria-hidden="true">
        @if (ctrlField().value) {
          <fcom-icon
            data-testid="icon-selected"
            [class]="iconSize()"
            [name]="
              theme() === CheckBoxTheme.SQUARE
                ? SvgLibraryIcon.CHECKBOX_SELECTED
                : SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED
            "
          ></fcom-icon>
        } @else {
          <fcom-icon
            data-testid="icon-unselected"
            [class]="iconSize()"
            [name]="
              theme() === CheckBoxTheme.SQUARE
                ? SvgLibraryIcon.CHECKBOX_UNSELECTED
                : SvgLibraryIcon.CHECKMARK_BUTTON_UNSELECTED
            "
          ></fcom-icon>
        }
      </span>
    }
    <div class="flex flex--column">
      @if (translationPrefix() && useLabelText()) {
        <span class="text font-body-1 medium-type"
          >{{ translationPrefix() + '.label' | finLocalization }}
          @if (required()) {
            *
          }
        </span>
      }
      <span data-testid="text-content" class="text">
        <ng-content />
      </span>
    </div>
  </label>

  @if (translationPrefix() && ctrlField().invalid && ctrlField().touched) {
    <div
      data-testid="error-label"
      class="error-label error-900-text font-body-2"
      id="checkbox-error-box"
      aria-live="polite"
    >
      @if (required()) {
        <span>{{ translationPrefix() + '.required' | finLocalization }}</span>
      }
    </div>
  }
</div>
